var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampsTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 642.84 79.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fbc445;stroke-miterlimit:10;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.42,14.54H48.49V66.65H33.67V14.54H.75V1.6H81.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.28,1.6h14.83V66.65H88.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177,66.65l-4.25-37L158.58,59.2H147.25L133.08,29.74l-4.34,36.91h-15.2l8-65.05h12.36l19,40.69L171.61,1.6h12.65l7.93,65.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.21,47.39H214c0,4.16,4.16,7.37,9.26,7.37,4.81,0,8.49-2.17,8.49-6.42,0-2.55-1.41-4.91-7.17-6.8l-7.74-2.36c-14.36-3.87-17.09-12.65-17.09-18.79,0-11.71,10-19.64,22.94-19.64,12.46,0,22,7.46,22,20.11H229.9c0-3.87-2.37-7.18-7.46-7.18-4.63,0-7.65,2.84-7.65,6.42,0,1.33.38,4.25,6.42,5.95l6.8,2.08c9.25,2.83,18.69,7.65,18.69,19.45,0,14-12.08,19.92-24,19.92C208.84,67.5,199.21,59.38,199.21,47.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.37,34A33.08,33.08,0,0,1,334.79,15.2l-11.51,8a17.42,17.42,0,0,0-15.2-8.4c-11,0-18.8,8.4-18.8,19.17s7.56,19.45,18.7,19.45a17.36,17.36,0,0,0,15.3-8.5l11.51,8.12A33.13,33.13,0,0,1,274.37,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.24,51.55H356.39l-4.81,15.1H335.71L359.79,1.6h16.15l24,65.05H384.15Zm-4.15-12.84L367.72,16l-7.27,22.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.51,66.65l-4.25-37L449.09,59.2H437.76L423.6,29.74l-4.34,36.91h-15.2l8-65.05h12.37l19,40.69L462.13,1.6h12.65l7.93,65.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.29,23.13c0,10.86-6.79,21.43-21.9,21.43h-59.2V66.65H493.36V1.6h74C582.5,1.6,589.29,12.36,589.29,23.13Zm-14.92,0c0-4.16-2.07-8.59-7.55-8.59H508.19V31.62h58.54C572.3,31.62,574.37,27.28,574.37,23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M594.6,47.39h14.82c0,4.16,4.16,7.37,9.26,7.37,4.81,0,8.49-2.17,8.49-6.42,0-2.55-1.41-4.91-7.17-6.8l-7.74-2.36c-14.36-3.87-17.09-12.65-17.09-18.79,0-11.71,10-19.64,22.94-19.64,12.46,0,22,7.46,22,20.11H625.29c0-3.87-2.36-7.18-7.46-7.18-4.63,0-7.65,2.84-7.65,6.42,0,1.33.38,4.25,6.42,5.95l6.8,2.08c9.25,2.83,18.69,7.65,18.69,19.45,0,14-12.08,19.92-24,19.92C604.23,67.5,594.6,59.38,594.6,47.39Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampsTitle);
export default __webpack_public_path__ + "static/media/camps-title.dc94535c935f8a4560073951528d26b9.svg";
export { ForwardRef as ReactComponent };